import { useEffect, useState } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useLocations = () => {
  const [locations, setLocations] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { cityId } = useAuth();

  useEffect(() => {
    if (!cityId) {
      return;
    }
    setLoading(true);
    let url = "/locations";
    if (cityId) {
      url = `/cities/${cityId}/locations`;
    }
    fetch(`${apiRoot}${url}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setLocations(json);
            setError(false);
            setLoading(false);

          });
        } else {
          setError(true);
          setLocations([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setLocations([]);
        setLoading(false);
      });
  }, [cityId]);

  return {
    locations,
    error,
    loading,
  };
};

export default useLocations;
